const INDUSTRY_KEY_MAP = {
  Technology: "technology", Finance: "finance", Healthcare: "healthcare", Marketing: "marketing",
  Education: "education", Legal: "legal", Operations: "operations", Engineering: "engineering",
  Retail: "retail", Media: "media", "Real Estate": "realEstate", Hospitality: "hospitality",
};

/** Translates a raw company.industry enum value (e.g. "Technology") into the
 *  active language, falling back to the raw value if no mapping exists. */
export function industryLabel(value, t) {
  if (!value) return value;
  const key = INDUSTRY_KEY_MAP[value];
  if (key) {
    const translated = t(`companies.industryNames.${key}`, null);
    if (translated) return translated;
  }
  return t(`categories.${value}`, value);
}
